var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c(
      "div",
      { staticClass: "channel-header" },
      [
        _vm.channel.thumbnail
          ? _c("img", {
              staticClass: "thumbnail",
              attrs: { src: _vm.channel.thumbnail },
            })
          : _vm._e(),
        _c(
          "div",
          { staticClass: "channel-name" },
          [
            _c(
              "KTooltip",
              {
                attrs: {
                  reference: "lockicon",
                  refs: _vm.$refs,
                  placement: "right",
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$tr("unlistedChannelTooltip")) +
                    "\n      "
                ),
              ]
            ),
            _c(
              "h1",
              [
                _c(
                  "KLabeledIcon",
                  {
                    attrs: { icon: "channel" },
                    scopedSlots: _vm._u([
                      {
                        key: "iconAfter",
                        fn: function () {
                          return [
                            _vm.channel.public === false
                              ? _c("KIcon", {
                                  ref: "lockicon",
                                  attrs: { icon: "unlistedchannel" },
                                })
                              : _vm._e(),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  },
                  [
                    _c("TextTruncatorCss", {
                      attrs: { text: _vm.channel.name },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "KFixedGrid",
          { attrs: { numCols: "4" } },
          [
            _c(
              "KFixedGridItem",
              {
                staticClass: "version",
                attrs: { span: _vm.windowIsSmall ? 4 : 1 },
              },
              [
                _c(
                  "p",
                  { style: [_vm.windowIsSmall ? { marginBottom: 0 } : {}] },
                  [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.$tr("version", { version: _vm.versionNumber })
                        ) +
                        "\n        "
                    ),
                  ]
                ),
              ]
            ),
            _c(
              "KFixedGridItem",
              {
                attrs: {
                  span: _vm.windowIsSmall ? 4 : 3,
                  alignment: _vm.windowIsSmall ? "left" : "right",
                },
              },
              [_c("p", [_vm._t("default")], 2)]
            ),
          ],
          1
        ),
        _c("p", { attrs: { dir: "auto" } }, [
          _vm._v("\n      " + _vm._s(_vm.channel.description) + "\n    "),
        ]),
      ],
      1
    ),
    _c("table", { staticClass: "channel-statistics" }, [
      _c("tr", { staticClass: "headers" }, [
        _c("th"),
        _c("th", [_vm._v(_vm._s(_vm.coreString("resourcesLabel")))]),
        _c("th", [_vm._v(_vm._s(_vm.$tr("sizeCol")))]),
      ]),
      _c("tr", [
        _c("th", [_vm._v(_vm._s(_vm.$tr("totalSizeRow")))]),
        _c("td", [
          _vm._v(
            _vm._s(
              _vm.$formatNumber(_vm.channel.total_resources || 0, {
                useGrouping: true,
              })
            )
          ),
        ]),
        _c("td", [
          _vm._v(_vm._s(_vm.bytesForHumans(_vm.channel.total_file_size || 0))),
        ]),
      ]),
      _c("tr", [
        _c("th", [_vm._v(_vm._s(_vm.$tr("onDeviceRow")))]),
        _c("td", [
          _vm._v(
            _vm._s(
              _vm.$formatNumber(_vm.channel.on_device_resources || 0, {
                useGrouping: true,
              })
            )
          ),
        ]),
        _c("td", [
          _vm._v(
            _vm._s(_vm.bytesForHumans(_vm.channel.on_device_file_size || 0))
          ),
        ]),
      ]),
      _vm.channel.new_resource_count !== null
        ? _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$tr("newOrUpdatedLabel")))]),
            _c("td", [
              _vm._v(
                _vm._s(
                  _vm.$formatNumber(_vm.channel.new_resource_count || 0, {
                    useGrouping: true,
                  })
                )
              ),
            ]),
            _c("td", [
              _vm._v(
                _vm._s(
                  _vm.bytesForHumans(_vm.channel.new_resource_total_size || 0)
                )
              ),
            ]),
          ])
        : _vm._e(),
      !_vm.remoteContentEnabled && _vm.freeSpace !== null
        ? _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$tr("freeDisk")))]),
            _c("td"),
            _c("td", [_vm._v(_vm._s(_vm.bytesForHumans(_vm.freeSpace || 0)))]),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }